import { BROKER_SOURCE_OPTIONS } from "../constants/realEstateFilters";
import { hasMapLocation } from "./brokerListings";
import { mapCanonicalApiListing } from "./canonicalProperties";
import { formatPropertyPrice } from "./realEstateFormat";

export function formatCanonicalPriceRange(listing) {
  const currency = listing.currency || listing.currencyCode || "COP";
  const min = listing.priceMin ?? listing.price;
  const max = listing.priceMax ?? listing.price;

  if (min == null && max == null) {
    return "—";
  }

  if (min != null && max != null && min !== max) {
    return `${formatPropertyPrice(min, currency)} – ${formatPropertyPrice(max, currency)}`;
  }

  return formatPropertyPrice(min ?? max, currency);
}

export function mapCanonicalListingToCard(listing) {
  return mapCanonicalApiListing(listing);
}

export function computeCanonicalListingCounts(listings = [], summary = null) {
  const total = summary?.totalCanonicalListings ?? listings.length;
  const mapped =
    summary?.mappedCanonicalListings ??
    listings.filter((listing) => hasMapLocation(listing)).length;
  const missingLocation =
    summary?.missingLocationCanonicalListings ?? Math.max(0, total - mapped);

  const bySource = summary?.bySource || null;
  const bySourceLabels = bySource
    ? BROKER_SOURCE_OPTIONS.map((option) => ({
        id: option.id,
        label: option.label,
        count: bySource[option.id] ?? 0,
      })).filter((entry) => entry.count > 0)
    : computeBySourceFromCanonicalListings(listings);

  return { total, mapped, missingLocation, bySourceLabels };
}

function computeBySourceFromCanonicalListings(listings = []) {
  const counts = Object.fromEntries(BROKER_SOURCE_OPTIONS.map((option) => [option.id, 0]));

  listings.forEach((listing) => {
    const sources = listing.sources || (listing.sourceSummary || []).map((entry) => entry.source);
    sources.forEach((source) => {
      if (source && counts[source] !== undefined) {
        counts[source] += 1;
      }
    });
  });

  return BROKER_SOURCE_OPTIONS.map((option) => ({
    id: option.id,
    label: option.label,
    count: counts[option.id] ?? 0,
  })).filter((entry) => entry.count > 0);
}

export function getSourceLinks(listing) {
  return (listing.sourceSummary || []).filter((entry) => entry.detailUrl);
}
